export default "__VITE_ASSET__92fe52b8__"